// extracted by mini-css-extract-plugin
module.exports = {"popupContainerStyle":"styles_popupContainerStyle__1kl-e"};